import { whenSelectorVisible } from '~/common/helpers/dom'

async function initializeTrix() {
  import('./main')
}

whenSelectorVisible('trix-editor', '800px').then(initializeTrix)
